import { render, staticRenderFns } from "./SeeAllDataClient.vue?vue&type=template&id=23df92a2"
import script from "./SeeAllDataClient.vue?vue&type=script&lang=js"
export * from "./SeeAllDataClient.vue?vue&type=script&lang=js"
import style0 from "./SeeAllDataClient.vue?vue&type=style&index=0&id=23df92a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports